import { styled } from '@mui/material/styles'
import {
  TextareaAutosize,
  Tabs,
  Tab,
  Box,
  TableContainer,
  TableHead,
} from '@mui/material'

export const StyledTextArea = styled(TextareaAutosize)(
  ({ error, theme, disabled }) => ({
    fontSize: '14px',
    borderRadius: '6px',
    paddingLeft: '10px',
    boxSizing: 'border-box',
    fontFamily: theme.typography.fontFamily,
    border: `1px solid ${error ? theme.palette.error.main : '#0000003b'}`,
    backgroundColor: theme.palette.background.default,
    resize: 'vertical',
    '&:hover': {
      borderColor: disabled ? '#0000003b' : theme.palette.black,
    },
    '&:focus': {
      outline: 'none',
      borderColor: error
        ? theme.palette.error.main
        : theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${
        error ? theme.palette.error.main : theme.palette.primary.main
      }`,
    },
  })
)

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: '16px',
  borderBottom: '1px solid #e0e0e0',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: '3px',
  },
}))

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  color: '#666',
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  '&:hover': {
    color: theme.palette.primary.main,
    opacity: 0.8,
  },
}))

export const StyledComponentSection = styled(Box)(({ theme }) => ({
  marginBottom: '24px',
}))

export const StyledTableContainer = styled(TableContainer)(() => ({
  borderRadius: '10px',
  boxShadow: '0px 4px 15px 0px #4047761A, 0px 8px 4px 0px #DDDFE840',
}))

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  '& .MuiTableCell-root': {
    backgroundColor: theme.palette.secondary.main,
  },
}))

export const StyledPaperStyle = {
  padding: '13px 24px',
  borderRadius: 2,
  width: '100%',
  boxShadow: '0px 4px 15px 0px #4047761A, 0px 8px 4px 0px #DDDFE840',
  '&:hover': {
    cursor: 'pointer',
  },
}
